import React, { useEffect, useState } from "react";
import { FiUsers } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { useParams } from "react-router-dom";

const CareTeamCard = ({ onExportData }) => {
  const [data, setData] = useState([]);

  const { pid } = useParams();

  const fetchCarePlans = async () => {
    try {
      const payload = {
        patientId: pid,
      };

      const encryptedPayload = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.post(
        "vozo/patient/getcarePlan",
        encryptedPayload,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo");

      const formatted = (Array.isArray(decryptedData) ? decryptedData : [])
        .map((item) => {
          const parsedTeam = item.care_team ? JSON.parse(item.care_team) : [];

          const isDraft = (item.status || "").toLowerCase() === "draft";

          const providerName = isDraft
            ? parsedTeam?.[0]?.provider_name || "-"
            : item.primary_provider_name || "-";

          const role = isDraft ? "Care Team Member" : "Primary Provider";

          return {
            id: item.id,
            name: providerName,
            role,
            contact: item.care_plan_name || "-",
          };
        })
        .sort((a, b) => b.id - a.id);

      /* UI → latest 3 */

      const latestData = formatted.slice(0, 3);

      setData(latestData);

      /* PARENT → FULL ARRAY */

      if (onExportData) {
        onExportData(
          formatted.map((item) => ({
            providerName: item.name,
            role: item.role,
            carePlan: item.contact,
          })),
        );
      }
    } catch (error) {
      console.log("Care Team Error", error);

      setData([]);
    }
  };

  useEffect(() => {
    fetchCarePlans();
  }, []);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiUsers className="care-summary-main-icon" />

        <h3 className="care-summary-title">Care Team</h3>
      </div>

      <div className="care-summary-body">
        {data.map((item, index) => (
          <div
            key={index}
            className={`care-summary-row-column ${
              index !== data.length - 1 ? "care-summary-border" : ""
            }`}
          >
            <div className="care-summary-heading">{item.name}</div>

            <div className="care-summary-subtext dark-sub">{item.role}</div>

            <div className="care-summary-subtext">
              Care Plan : {item.contact}
            </div>
          </div>
        ))}

        {data.length === 0 && (
          <div className="care-summary-empty">No Care Team Added</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(CareTeamCard);
